import { NgModule } from "@angular/core";
import { SharedModule } from "../../../shared/shared.module";

import { AppInfoRoutingModule } from "./app-info-routing.module";

@NgModule({
  imports: [AppInfoRoutingModule, SharedModule],
  declarations: [],
})
export class AppInfoModule {}
